import { Attrs, EventListeners, MinzeElement } from 'minze'
import { Locale } from '../../modules/locale'
import MainModule from '../../modules/main'
import { getContentTypeFromUrl } from '../../utils/gtm/utilities'

Locale.getInstance().registerKeySet('fr', 'shareButton', {
  share: 'Partager',
})

Locale.getInstance().registerKeySet('en', 'shareButton', {
  share: 'Share',
})

export interface LvcShare {
  dataButtonVariant?: 'round'
  dataEventName: string
}
export class LvcShare extends MinzeElement {
  attrs: Attrs = ['data-button-variant', ['data-event-name', 'unknown']]
  onButtonClick = () => {
    const mainModule = MainModule.getInstance()
    mainModule.injectIntoDOM('lvc-share-popup', [
      { name: 'data-event-name', value: this.dataEventName },
    ])
    try {
      mainModule.analyticsTrack('bouton_partage', {
        nom: this.dataEventName,
        content_type: getContentTypeFromUrl(window.location.pathname),
      })
    } catch (e) {
      console.error('Error tracking share button click:', e)
    }
  }
  html = () => `
    <button id='lvc-share-button' class="${this.dataButtonVariant === 'round' ? 'is-round' : ''}">
      ${this.dataButtonVariant === 'round' ? '' : `<div>${Locale.getKey('shareButton.share')}</div>`}
      <lvc-share-icon data-fill="${this.dataButtonVariant === 'round' ? '#FF4600' : '#1E007D'}"></lvc-share-icon>
    </button>
  `

  css = () => `
    :host {
      display: inline;
    }
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      background: none;
      color: #1E007D;
      height: 55px;
      padding-left: 24px;
      padding-right: 20px;
      border: 2px solid #1E007D;
      border-radius: 999px;
      line-height: 1;
      font-family: inherit;
      font-size: 14px;
      font-weight: inherit;
      transition: box-shadow .2s;
      min-width: 142px;
    }
    button.is-round {
      border: none;
      background: white;
      width: 55px;
      min-width: auto;
      border-radius: 50%;
      padding: 0;
      gap: 0px;
    }
    button:hover {
      box-shadow: 0 4px 4px 0 #00000040,0 14px 20px 0 #1e007d2e;
    }
    @media screen and (max-width: 767px) {
      button {
        height: 40px;
        font-size: 12px;
        min-width: 132px;
        font-size: 12px;
      }
      button.is-round {
        height: 35px;
        width: 35px;
        min-width: auto;
      }
    }
  `

  eventListeners: EventListeners = [['#lvc-share-button', 'click', this.onButtonClick]]
}
